// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global google */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __initGoogleMaps: function() {
            const map_wrapper = wntrTheme.body.find('.contact__map');

            if (map_wrapper.length > 0) {
                $.each(map_wrapper, function() {
                    const el = $(this);

                    const map = new google.maps.Map(el[0], {
                        zoom: 13,
                        disableDefaultUI: true,
                        center: new google.maps.LatLng(el.data('lat'), el.data('lng')),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        gestureHandling: 'cooperative',
                    });

                    new google.maps.Marker({
                        position: new google.maps.LatLng(el.data('lat'), el.data('lng')),
                        animation: google.maps.Animation.DROP,
                        icon: {
                            size: new google.maps.Size(36, 36),
                        },
                        map: map
                    });
                });

            }
        },
        

        // Show Banner
        __showBanner: function() {
            const imageBanner = wntrTheme.body.find('.page-section-image_banner');
            if (imageBanner.find('.no-image').length > 0) { 
                imageBanner.toggleClass('text-only-banner');
            }
        },
        
        // Mobile Menu Toggle
        __toggleMobileMenu: function() {
            const menuBtn = wntrTheme.body.find('.hamburger');
            const headerEl = wntrTheme.body.find('.header');
            const subMenuBtn = wntrTheme.body.find('.header__toggle-sub-menu');
            const menuItem = wntrTheme.body.find('.menu-item-has-children');
            const menuHeading = wntrTheme.body.find('.link-heading a').first();

            menuBtn.on('click', function() {
                $(this).toggleClass('is-active');
                headerEl.toggleClass('active-header');
            });

            menuHeading.on('click', function(e) {
                e.preventDefault();
            });

            if ($(window).width() > 1024) {
                menuItem.on('mouseover', function() {
                    subMenuBtn.addClass('is-active');
                    $(this).find('.sub-menu').toggleClass('is-active');
                });
                menuItem.on('mouseout', function() {
                    subMenuBtn.removeClass('is-active');
                    $(this).find('.sub-menu').toggleClass('is-active');
                });
            } else {
                menuItem.on('click', function() {
                    subMenuBtn.toggleClass('is-active');
                    $(this).find('.sub-menu').toggleClass('is-active');
                });
            }

        },

        // Slider
        __objectSlider: function() {
            const objectSlider = wntrTheme.body.find('.slider');
            if(wntrTheme.body.find(objectSlider)) {
                objectSlider.slick({
                    dots: false,
                    infinite: true,
                    speed: 1000,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    slidesToShow: 3,
                    centerMode: true,
                    centerPadding: '60px',
                    responsive: [
                        {
                          breakpoint: 1480,
                          settings: {
                            arrows: true,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 960,
                          settings: {
                            arrows: false,
                            slidesToShow: 2
                          }
                        },
                        {
                          breakpoint: 560,
                          settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 1
                          }
                        }
                      ]
                });
            }
        },

    };
 
    $(document).ready(wntrTheme.init);
})(jQuery);
